import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { compare } from '@nu-art/ts-common';
import { LL_H_C, performAction } from '@nu-art/thunderstorm-frontend/index';
import { QToastContent } from '../../../../../../q-components/index.js';
import { ModuleFE_VariableRelation } from '../../../../../../../_entity.js';
import { IconWithTooltip } from '@app/styles';
import React from 'react';
export default function RenderEditColumn(props) {
    const [enableEdit, setEnableEdit] = React.useState(false);
    React.useEffect(() => {
        const dbTable = ModuleFE_VariableRelation.cache.unique(props.row?._id);
        if ((!dbTable) || !(dbTable.leftSide.some((item, index) => compare(item, props.row?.leftSide[index])) &&
            dbTable.rightSide.some((item, index) => compare(item, props.row?.rightSide[index]))
            && compare(dbTable.relation, props.row.relation))) {
            setEnableEdit(true);
        }
    });
    const updateTable = async () => {
        let response;
        await performAction(async () => {
            response = await ModuleFE_VariableRelation.v1
                .upsert(props.row).executeSync();
            props.onSaveRow(response, props.index);
            setEnableEdit(false);
        }, {
            type: 'toast',
            successContent: _jsx(QToastContent, { content: 'Table updated successfully', toastType: 'success', iconKey: 'v' }),
        });
    };
    return (_jsxs(LL_H_C, { style: { width: '100%', justifyContent: 'center', gap: '10px' }, children: [_jsx(IconWithTooltip, { className: 'bin-size tooltip', iconKey: 'bin', content: 'Delete', onClick: () => props.removeARow(props.index) }), enableEdit &&
                _jsx(IconWithTooltip, { className: 'inner-values__actions__accept tooltip', iconKey: 'v', content: 'Save', onClick: () => updateTable() })] }));
}
//# sourceMappingURL=RenderEditColumn.js.map